const MyCardsWallet = () => {
    return (
        <>
            <section className="user-dashboard-section section-b-space">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-xxl-12 col-lg-12">
                            <div className="dashboard-right-sidebar">
                            <div className="dashboard-card">
                                <div className="title title-flex">
                                    <div>
                                        <h2>My Card Details</h2>
                                        <span className="title-leaf">
                                            <svg className="icon-width bg-gray">
                                                <use xlinkHref="../assets/svg/leaf.svg#leaf" />
                                            </svg>
                                        </span>
                                    </div>
                                    <button
                                        className="btn theme-bg-color text-white btn-sm fw-bold mt-lg-0 mt-3"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editCard"
                                    >
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={24}
                                            height={24}
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth={2}
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            className="feather feather-plus me-2"
                                        >
                                            <line x1={12} y1={5} x2={12} y2={19} />
                                            <line x1={5} y1={12} x2={19} y2={12} />
                                        </svg>{" "}
                                        Add New Card
                                    </button>
                                </div>
                                <div className="row g-4">
                                    <div className="col-xxl-4 col-xl-6 col-lg-12 col-sm-6">
                                        <div className="payment-card-detail">
                                            <div className="card-details">
                                                <div className="card-number">
                                                    <h4>XXXX - XXXX - XXXX - 2548</h4>
                                                </div>
                                                <div className="valid-detail">
                                                    <div className="title">
                                                        <span>valid</span>
                                                        <span>thru</span>
                                                    </div>
                                                    <div className="date">
                                                        <h3>08/05</h3>
                                                    </div>
                                                    <div className="primary">
                                                        <span className="badge bg-pill badge-light">primary</span>
                                                    </div>
                                                </div>
                                                <div className="name-detail">
                                                    <div className="name">
                                                        <h5>Audrey Carol</h5>
                                                    </div>
                                                    <div className="card-img">
                                                        <img
                                                            src="../assets/images/payment-icon/1.jpg"
                                                            className="img-fluid blur-up lazyloaded"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="edit-card">
                                                <a
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#editCard"
                                                    href="javascript:void(0)"
                                                >
                                                    <i className="far fa-edit" /> edit
                                                </a>
                                                <a
                                                    href="javascript:void(0)"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#removeProfile"
                                                >
                                                    <i className="far fa-minus-square" /> delete
                                                </a>
                                            </div>
                                        </div>
                                        <div className="edit-card-mobile">
                                            <a
                                                data-bs-toggle="modal"
                                                data-bs-target="#editCard"
                                                href="javascript:void(0)"
                                            >
                                                <i className="far fa-edit" /> edit
                                            </a>
                                            <a href="javascript:void(0)">
                                                <i className="far fa-minus-square" />
                                                delete
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-xxl-4 col-xl-6 col-lg-12 col-sm-6">
                                        <div className="payment-card-detail">
                                            <div className="card-details card-visa">
                                                <div className="card-number">
                                                    <h4>XXXX - XXXX - XXXX - 1536</h4>
                                                </div>
                                                <div className="valid-detail">
                                                    <div className="title">
                                                        <span>valid</span>
                                                        <span>thru</span>
                                                    </div>
                                                    <div className="date">
                                                        <h3>12/23</h3>
                                                    </div>
                                                    <div className="primary">
                                                        <span className="badge bg-pill badge-light">primary</span>
                                                    </div>
                                                </div>
                                                <div className="name-detail">
                                                    <div className="name">
                                                        <h5>Leah Heather</h5>
                                                    </div>
                                                    <div className="card-img">
                                                        <img
                                                            src="../assets/images/payment-icon/2.jpg"
                                                            className="img-fluid blur-up lazyloaded"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="edit-card">
                                                <a
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#editCard"
                                                    href="javascript:void(0)"
                                                >
                                                    <i className="far fa-edit" /> edit
                                                </a>
                                                <a
                                                    href="javascript:void(0)"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#removeProfile"
                                                >
                                                    <i className="far fa-minus-square" /> delete
                                                </a>
                                            </div>
                                        </div>
                                        <div className="edit-card-mobile">
                                            <a
                                                data-bs-toggle="modal"
                                                data-bs-target="#editCard"
                                                href="javascript:void(0)"
                                            >
                                                <i className="far fa-edit" /> edit
                                            </a>
                                            <a href="javascript:void(0)">
                                                <i className="far fa-minus-square" />
                                                delete
                                            </a>
                                        </div>
                                    </div>
                                    <div className="col-xxl-4 col-xl-6 col-lg-12 col-sm-6">
                                        <div className="payment-card-detail">
                                            <div className="card-details debit-card">
                                                <div className="card-number">
                                                    <h4>XXXX - XXXX - XXXX - 1366</h4>
                                                </div>
                                                <div className="valid-detail">
                                                    <div className="title">
                                                        <span>valid</span>
                                                        <span>thru</span>
                                                    </div>
                                                    <div className="date">
                                                        <h3>05/21</h3>
                                                    </div>
                                                    <div className="primary">
                                                        <span className="badge bg-pill badge-light">primary</span>
                                                    </div>
                                                </div>
                                                <div className="name-detail">
                                                    <div className="name">
                                                        <h5>mark jecno</h5>
                                                    </div>
                                                    <div className="card-img">
                                                        <img
                                                            src="../assets/images/payment-icon/3.jpg"
                                                            className="img-fluid blur-up lazyloaded"
                                                            alt=""
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="edit-card">
                                                <a
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#editCard"
                                                    href="javascript:void(0)"
                                                >
                                                    <i className="far fa-edit" /> edit
                                                </a>
                                                <a
                                                    href="javascript:void(0)"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#removeProfile"
                                                >
                                                    <i className="far fa-minus-square" /> delete
                                                </a>
                                            </div>
                                        </div>
                                        <div className="edit-card-mobile">
                                            <a
                                                data-bs-toggle="modal"
                                                data-bs-target="#editCard"
                                                href="javascript:void(0)"
                                            >
                                                <i className="far fa-edit" /> edit
                                            </a>
                                            <a href="javascript:void(0)">
                                                <i className="far fa-minus-square" />
                                                delete
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div
  className="modal fade theme-modal"
  id="editCard"
  tabIndex={-1}
  aria-modal="true"
  role="dialog"
>
  <div className="modal-dialog modal-lg modal-dialog-centered modal-fullscreen-sm-down">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel8">
          Edit Card
        </h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal">
          <i className="fa-solid fa-xmark" />
        </button>
      </div>
      <div className="modal-body">
        <div className="row g-4">
          <div className="col-xxl-6">
            <form>
              <div className="form-floating theme-form-floating">
                <input
                  type="text"
                  className="form-control"
                  id="finame"
                  defaultValue="Mark"
                />
                <label htmlFor="finame">First Name</label>
              </div>
            </form>
          </div>
          <div className="col-xxl-6">
            <form>
              <div className="form-floating theme-form-floating">
                <input
                  type="text"
                  className="form-control"
                  id="laname"
                  defaultValue="Jecno"
                />
                <label htmlFor="laname">Last Name</label>
              </div>
            </form>
          </div>
          <div className="col-xxl-4">
            <form>
              <div className="form-floating theme-form-floating">
                <select className="form-select" id="floatingSelect12">
                  <option selected="">Card Type</option>
                  <option value="kingdom">Visa Card</option>
                  <option value="states">MasterCard Card</option>
                  <option value="fra">RuPay Card</option>
                  <option value="china">Contactless Card</option>
                  <option value="spain">Maestro Card</option>
                </select>
                <label htmlFor="floatingSelect12">Card Type</label>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-animation btn-md fw-bold"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
        <button
          type="button"
          className="btn theme-bg-color btn-md fw-bold text-light"
        >
          Update Card
        </button>
      </div>
    </div>
  </div>
            </div>

            <div
  className="modal fade theme-modal remove-profile"
  id="removeProfile"
  tabIndex={-1}
  aria-modal="true"
  role="dialog"
>
  <div className="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
    <div className="modal-content">
      <div className="modal-header d-block text-center">
        <h5 className="modal-title w-100" id="exampleModalLabel22">
          Are You Sure ?
        </h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal">
          <i className="fa-solid fa-xmark" />
        </button>
      </div>
      <div className="modal-body">
        <div className="remove-box">
          <p>
            The permission for the use/group, preview is inherited from the
            object, object will create a new permission for this object
          </p>
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-animation btn-md fw-bold"
          data-bs-dismiss="modal"
        >
          No
        </button>
        <button
          type="button"
          className="btn theme-bg-color btn-md fw-bold text-light"
          data-bs-target="#removeAddress"
          data-bs-toggle="modal"
        >
          Yes
        </button>
      </div>
    </div>
  </div>
</div>

       
        </>)
}

export default MyCardsWallet;